// @ngInject
function DashboardApiService($q, DS, ResourcesService, DSHttpAdapter) {

    return {
        getWidgetDefinitions: getWidgetDefinitions,
        getWidgets: getWidgets,
        getWidgetData: getWidgetData,
        saveWidgets: saveWidgets
    };

    function getWidgets() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'dashboard/getdashboard/').then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getWidgetDefinitions() {
        var deferred = $q.defer();

        DSHttpAdapter.GET(DS.defaults.basePath + 'dashboard/getwidgetdefinitions/').then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function getWidgetData(widget_id, settings) {
        var deferred = $q.defer();

        settings = settings !== undefined && settings !== "" && angular.isString(settings) ? JSON.parse(settings) : settings;

        var request = {
            locationIds: settings === undefined || settings === null ? undefined: settings.locationIds,
            hideTooltip: settings === undefined || settings === null ? undefined: settings.hideTooltip,
            businessAreaId: settings === undefined || settings === null ? undefined: settings.businessAreaId,
            selectedWidgetTimeFrame: settings === undefined || settings === null ? undefined: settings.selectedWidgetTimeFrame
        };

        if(settings === undefined || settings === null || settings.locationIds === undefined) {
            request.locationIds = [];
            if(settings !== null && settings !== '' && settings !== undefined && !isNaN(parseInt(settings))) {
                request.locationIds.push(parseInt(settings));
            }
        }

        var jsonRequest = angular.toJson(request);

        DSHttpAdapter.POST(DS.defaults.basePath + 'dashboard/getwidgetdata/' + widget_id, jsonRequest).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });
        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }

    function saveWidgets(data) {
        var deferred = $q.defer();

        var request = data;

        _.forEach(request, function(value) {
            if(value.setting !== undefined && value.setting !== null &&
                (value.setting.locationIds !== undefined || value.setting.businessAreaId !== undefined)) {
                value.setting = angular.toJson(value.setting);
            }
        });

        DSHttpAdapter.POST(DS.defaults.basePath + 'dashboard/saveWidgets', request).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(handleError(error));
        });
        return deferred.promise;
    }

}

angular.module('dashboard.api', [])
    .factory('DashboardApiService', DashboardApiService);
